import { FC } from "react";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { useThemedCollectionColors } from "@/mds/themes/use-themed-collection-colors";

type Props = {
  kind: MemCommonMentionKind | "create-new-collection";
  collectionId?: string;
};

export const MDSComboboxListItemIcon: FC<Props> = ({ kind, collectionId }) => {
  const isCollection = kind === MemCommonMentionKind.Collection;
  const isNote = kind === MemCommonMentionKind.Note;
  const isCreateNew = kind === "create-new-collection";
  const { iconColor } = useThemedCollectionColors(collectionId);

  if (isCreateNew) {
    return <MDSIcon kind={MDSIconKind.Plus} color={MDSIconColor.Secondary} />;
  }

  if (isCollection) {
    return <MDSIcon kind={MDSIconKind.Collection} size={11} overrideColor={iconColor} />;
  }

  if (isNote) {
    return <MDSIcon kind={MDSIconKind.Document} size={11} color={MDSIconColor.Secondary} />;
  }

  return null;
};
